import React from "react";

const Input = ({ name, label, error, value, ...rest }) => {
  return (
    <React.Fragment>
      <div className="form-group">
        <label className="form-control-label" htmlFor={name}>
          {label}
        </label>
        <input
          {...rest}
          value={value ?? ""}
          id={name}
          name={name}
          className="form-control"
          placeholder={label}
        />
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </React.Fragment>
  );
};

export default Input;
